import { render, staticRenderFns } from "./BookCardList.vue?vue&type=template&id=748b98e1&"
import script from "./BookCardList.vue?vue&type=script&lang=js&"
export * from "./BookCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports